'use client';

import dynamic from 'next/dynamic';
import { Suspense, useState } from 'react';

import { useConsent } from './use-consent';

const ConsentBannerContent = dynamic(() =>
  import('./consent-banner-content').then((m) => m.ConsentBannerContent),
);

export interface ConsentBannerProps {
  /**
   * URL to the privacy policy
   * Defaults to healthcare.com production privacy policy
   */
  privacyPolicyUrl?: string;
}

export function ConsentBanner({
  privacyPolicyUrl = 'https://www.healthcare.com/privacy-policy#additional-information-about-our-data-collection-and-sharing-practices',
}: ConsentBannerProps) {
  const [open, setOpen] = useState(true);
  const { status, saveConsent } = useConsent();

  // Don't show if user has already made a choice or manually closed
  const shouldShow = open && status === 'unknown';

  if (!shouldShow) {
    return null;
  }

  return (
    <div
      data-testid="consent-banner"
      className="fixed bottom-0 left-0 right-0 z-[60] rounded-t bg-primary-900 text-tertiary-50 sm:bottom-16-16 sm:left-auto sm:right-16-16 sm:max-w-[30rem] sm:rounded"
    >
      <Suspense fallback={null}>
        {
          <ConsentBannerContent
            privacyPolicyUrl={privacyPolicyUrl}
            saveConsent={saveConsent}
            setOpen={setOpen}
          />
        }
      </Suspense>
    </div>
  );
}
